import { render, staticRenderFns } from "./AuthorView.vue?vue&type=template&id=1fbf4862&"
import script from "./AuthorView.vue?vue&type=script&lang=js&"
export * from "./AuthorView.vue?vue&type=script&lang=js&"
import style0 from "./AuthorView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports